import apiClient from './apiClient';

const BASE_URL = '/feedback';

const construirMultipartTicket = (data, file) => {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
    if (file) {
        formData.append('adjunto', file);
    }
    return formData;
};

const construirMultipartActividad = (data, file) => {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
    if (file) {
        formData.append('adjunto', file);
    }
    return formData;
};

export const feedbackService = {
    listarTickets: () => apiClient.get(`${BASE_URL}/tickets`),
    obtenerTicket: (id) => apiClient.get(`${BASE_URL}/tickets/${id}`),
    listarEtiquetas: () => apiClient.get(`${BASE_URL}/etiquetas`),
    crearTicket: (data, file) => apiClient.post(`${BASE_URL}/tickets`, construirMultipartTicket(data, file), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    agregarActividad: (ticketId, data, file) => apiClient.post(`${BASE_URL}/tickets/${ticketId}/actividades`, construirMultipartActividad(data, file), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    cambiarEstado: (ticketId, estado) => apiClient.patch(`${BASE_URL}/tickets/${ticketId}/estado`, { estado }),
    tomarTicket: (ticketId) => apiClient.post(`${BASE_URL}/tickets/${ticketId}/tomar`),
    rechazarTicket: (ticketId, motivo) => apiClient.post(`${BASE_URL}/tickets/${ticketId}/rechazar`, { motivo }),
};
